import winner from '../images/winner_en.png';
//import bonusSpin from '../images/bonus-spin_en.png'
import betterLuckNextTime from '../images/better-luck-next-time_en.png';

const prizeEn = [
  {
    option: 'BETTER LUCK NEXT TIME',
    image: { uri: betterLuckNextTime, sizeMultiplier: 1.6 },
    style: { backgroundColor: '#f6b01a' },
  },
  {
    option: 'WINNER!',
    image: { uri: winner, sizeMultiplier: 1.3 },
    style: { backgroundColor: '#0d7d7f' },
  },
  {
    option: 'WINNER!',
    image: { uri: winner, sizeMultiplier: 1.3 },
    style: { backgroundColor: '#3abb9d' },
  },
  {
    option: 'WINNER!',
    image: { uri: winner, sizeMultiplier: 1.3 },
    style: { backgroundColor: '#242c5b' },
  },
];

export { prizeEn };
